import { Link } from "react-router-dom";

interface NewsCardProps {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
  cover: string;
}

export default function NewsCard({ id, title, date, category, summary, cover }: NewsCardProps) {
  return (
    <Link
      to={`/news/${id}`}
      className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row"
    >
      <div className="h-40 w-full shrink-0 overflow-hidden rounded-md bg-secondary-200 sm:h-32 sm:w-52">
        <img
          src={cover}
          alt={`${title}`}
          title={`${title} - 年轻的母亲2影视资讯`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col">
        <div className="flex items-center gap-2">
          <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-xs font-semibold text-accent-800">
            {category}
          </span>
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-time-line text-sm"></i>
            </span>
            {date}
          </span>
        </div>
        <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 line-clamp-2">
          {title}
        </h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-2">
          {summary}
        </p>
      </div>
    </Link>
  );
}